import SheetsContainer from '../../components/sheets/container.vue';

const Plugin = {
  install(Vue) {
    if (this.installed) return;
    this.installed = true;

    const subscription = new Vue();

    function show(...args) {
      let [sheetType, options] = args;
      subscription.$emit('show', { sheetType, options });
    }

    function hide(...args) {
      let [sheetType] = args;
      subscription.$emit('hide', { sheetType });
    }

    Vue.prototype.$sheets = {
      show,
      hide,
      subscription,
    };

    Vue.component('SheetsContainer', SheetsContainer);
  },
};

export default Plugin;
